module.exports = __webpack_public_path__ + "static/media/channbackground.3763f85f.JPG";